export const USER_CATEGORY = {
  MEMBER: 1,
  SME: 2,
  ADMIN: 3,
  SUPERADMIN: 4,
};